export default __webpack_public_path__ + "static/media/beep4.38d23ee0.mp3";